import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import CircleAnnouncement from '../index';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import anime from 'animejs';
import dataModel from '../../../../models/DataModel';

import './CircleAnnouncementWalkthrough.scss';

/**
 * CircleAnnouncementWalkthrough is a <CircleGlobalModal> which is used to display an initial
 * fullscreen push notifications announcement/overlay to the user. Users should only see this once.
 */
export class CircleAnnouncementWalkthrough extends Component {

  constructor(props) {

    CircleAnnouncementWalkthrough.propTypes = {
      /** onClose - Function called by the parent when the modal is closed */
      onClose: PropTypes.func,
      modalType: PropTypes.string,
    };

    super(props);
    this.state = {
      status: null,
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    
    this.handleClose = this.handleClose.bind(this);
    this.expandAnnouncement = this.expandAnnouncement.bind(this);
    this.collapseAnnouncement = this.collapseAnnouncement.bind(this);
  }

  componentDidMount() {
    const { announcementSettings } = this.props.modalProps;
    setTimeout(() => {
      this.expandAnnouncement();
    }, announcementSettings.slideTimeout);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.displayHighlight != this.state.displayHighlight) {
      setTimeout(() => {
        this.setState({ highlightVisible: true });
      }, 10);
    }
    if (prevProps.closeDisplay != this.props.closeDisplay) {
      this.collapseAnnouncement();
    }
  }

  expandAnnouncement() {
    if (dataModel.mobileBridge.isMobile) {
      let toX;
      let toY;
      const { translateX, translateY } = this.props.modalProps.announcementSettings;
      if (dataModel.mobileBridge.isMobile) {
        if (translateX || translateY) {
          toX = translateX;
          toY = translateY;
          this.collapseTo = { x: toX * -1, y: toY * -1 };
        }
      }
      dataModel.setDisableAppBackground(true);
      const self = this;
      return anime({
        targets: `#${this.props.modalType}`,
        translateX: toX,
        translateY: toY,
        easing: 'easeInOutCubic',
        duration: 1000,
        complete: () => {
          self.setState({ displayHighlight: true });
        },
      });
    }
  }

  collapseAnnouncement() {
    const { dontCloseOnCollapse } = this.props;
    if (dontCloseOnCollapse) {
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
    this.setState({ highlightHide: true });
    setTimeout(() => {
      return anime({
        targets: `#${this.props.modalType}`,
        translateY: this.collapseTo.y,
        translateX: this.collapseTo.x,
        easing: 'easeInOutCubic',
        duration: 1000,
        complete: () => {
          dataModel.setDisableAppBackground(false);
          if (!dontCloseOnCollapse) {
            this.handleClose();
          }
        },
      });
    }, 100);
  }

  handleClose() {
    let { currentUser } = this.props;
    if (!currentUser.settings) {
      currentUser.settings = {};
    }
    currentUser.settings[this.props.modalProps.userSetting] = true;
    const updateUser = _.cloneDeep(currentUser);
    dataModel.usersDAO.updateUser(updateUser);
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    let swoopArrow = null;
    const { announcementSettings } = this.props.modalProps;
    if (dataModel.mobileBridge.isMobile) {
      if (announcementSettings) {
        let swoopArrowStyle = {
          left: announcementSettings.swoopArrowSettings.left,
          top: announcementSettings.swoopArrowSettings.top,
          transform: (announcementSettings.swoopArrowSettings.rotateY ?
            'rotateY(' + announcementSettings.swoopArrowSettings.rotateY + 'deg) ' : '') + 'rotate(' + announcementSettings.swoopArrowSettings.rotate + 'deg) ',
        };
        swoopArrow = <div className="swoop-arrow" style={swoopArrowStyle} />;
      }
    }

    let displayHighlight = null;
    
    if (this.state.displayHighlight) {
      let className = 'delay-highlighter ' + (this.state.highlightHide ? ' hide' : this.state.highlightVisible ? ' visible' : '');

      if (announcementSettings && announcementSettings.highlightSettings) {
        let highlightStyle = { width: announcementSettings.highlightSettings.width, height: announcementSettings.highlightSettings.height };
        if (announcementSettings.highlightSettings.top) {
          highlightStyle.top = announcementSettings.highlightSettings.top;
        }
        if (announcementSettings.highlightSettings.bottom) {
          highlightStyle.bottom = announcementSettings.highlightSettings.bottom;
        }
        if (announcementSettings.highlightSettings.left) {
          highlightStyle.left = announcementSettings.highlightSettings.left;
        }
        if (announcementSettings.highlightSettings.right) {
          highlightStyle.right = announcementSettings.highlightSettings.right;
        }

        if (announcementSettings.highlightSettings.internalElement) {
          displayHighlight = <div className={className} style={highlightStyle}>{announcementSettings.highlightSettings.internalElement}</div>;
        }
        else {
          displayHighlight = <div className={className} style={highlightStyle}/>;
        }
      }
    }

    return (
      <div className={'delays-announcement-circle-announcement ' +
        this.props.modalType + ' ' + announcementSettings.circlePositionOnScreen}
        id={this.props.modalType}>
        {displayHighlight}
        <CircleAnnouncement
          headingText={announcementSettings.headingText }
          bodyText={announcementSettings.bodyText}
          buttonText={announcementSettings.buttonText}
          onClose={this.collapseAnnouncement}
          allignment={announcementSettings.contents_allignment}
          swoopArrow={swoopArrow}
        >
        </CircleAnnouncement>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(CircleAnnouncementWalkthrough);



// WEBPACK FOOTER //
// ./src/components/modals/CircleAnnouncement/CircleAnnouncementWalkthrough/index.js